import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfHttpService } from './conf-http.service';

@Injectable({
  providedIn: 'root'
})
export class TestService {
  // endpopint = 'http://api.crabslogistica.dotsystems.com.ar/api/';
  endpopint = 'http://200.41.185.140/apinittida/api/Incidencia';
  headers= new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http: HttpClient, conf:ConfHttpService) {
     this.endpopint=conf.getBackend();
   }

  get(){
    // return this.http.get<any>('http://200.41.185.140/apinittida/api/Incidencia');
  }
}
